import { render } from "./Avatar.Vue.vue?vue&type=template&id=7d69e2a6&scoped=true"
import script from "./Avatar.Vue.vue?vue&type=script&lang=js"
export * from "./Avatar.Vue.vue?vue&type=script&lang=js"

import "./Avatar.Vue.vue?vue&type=style&index=0&id=7d69e2a6&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d69e2a6"]])

export default __exports__